import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import WebsiteEventFormLayer from "../components/WebsiteEventFormLayer";

const WebsiteEventFormPage = () => {
    return (
        <MasterLayout>
            <WebsiteEventFormLayer />
        </MasterLayout>
    );
};

export default WebsiteEventFormPage;
